import { render, staticRenderFns } from "./VehicleGiftModal.vue?vue&type=template&id=66942794"
import script from "./VehicleGiftModal.vue?vue&type=script&lang=js"
export * from "./VehicleGiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports